function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M256.001,0C114.841,0,0,114.841,0,256.001s114.841,256.001,256.001,256.001S512.001,397.16,512.001,256.001 C512,114.841,397.16,0,256.001,0z M256.001,493.701c-131.069,0-237.702-106.631-237.702-237.7S124.932,18.299,256.001,18.299 s237.702,106.632,237.702,237.7C493.701,387.07,387.068,493.701,256.001,493.701z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M257.142,300.395c-37.723,0-73.189,14.69-99.863,41.364c-3.573,3.573-3.573,9.365,0,12.939c3.574,3.573,9.367,3.573,12.94,0 c23.217-23.218,54.087-36.005,86.923-36.005s63.706,12.787,86.923,36.005c1.787,1.787,4.128,2.68,6.471,2.68 c2.341,0,4.683-0.893,6.471-2.68c3.573-3.573,3.573-9.365,0-12.939C330.332,315.086,294.865,300.395,257.142,300.395z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M161.852,136.57c0-5.053-4.095-9.15-9.15-9.15s-9.15,4.097-9.15,9.15c0,26.857-21.849,48.707-48.707,48.707 c-5.054,0-9.15,4.097-9.15,9.15s4.095,9.15,9.15,9.15C131.792,203.575,161.852,173.517,161.852,136.57z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M417.155,185.276c-26.858,0-48.707-21.849-48.707-48.707c0-5.053-4.095-9.15-9.15-9.15c-5.054,0-9.15,4.097-9.15,9.15 c0,36.947,30.059,67.006,67.006,67.006c5.054,0,9.15-4.097,9.15-9.15C426.304,189.372,422.209,185.276,417.155,185.276z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M180.577,229.983c0-18.666-15.186-33.852-33.852-33.852s-33.852,15.186-33.852,33.852s15.186,33.852,33.852,33.852 S180.577,248.649,180.577,229.983z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M365.275,196.131c-18.666,0-33.852,15.186-33.852,33.852s15.186,33.852,33.852,33.852s33.852-15.186,33.852-33.852 S383.942,196.131,365.275,196.131z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var _ref19 =
/*#__PURE__*/
React.createElement("g", null);

var _ref20 =
/*#__PURE__*/
React.createElement("g", null);

var _ref21 =
/*#__PURE__*/
React.createElement("g", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      "enableBackground": "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve"
  }, props), React.createElement("circle", {
    style: {
      "fill": "#F7B239"
    },
    cx: 256.004,
    cy: 256.004,
    r: 246.855
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      "fill": "#E09B2D"
    },
    d: "M126.306,385.694c-88.801-88.802-95.798-228.426-20.998-325.242 C97.023,66.853,89.051,73.85,81.45,81.45c-96.401,96.401-96.401,252.698,0,349.099s252.698,96.401,349.099,0 c7.599-7.599,14.597-15.573,20.999-23.858C354.733,481.492,215.108,474.494,126.306,385.694z"
  }), React.createElement("path", {
    style: {
      "fill": "#E09B2D"
    },
    d: "M287.082,363.982c-1.431,0-2.882-0.337-4.237-1.046c-8.209-4.298-17.494-6.571-26.85-6.571 c-9.352,0-18.633,2.272-26.841,6.569c-4.474,2.345-10.005,0.616-12.351-3.861c-2.344-4.476-0.615-10.006,3.861-12.349 c10.817-5.664,23.034-8.658,35.331-8.658c12.299,0,24.52,2.994,35.337,8.658c4.477,2.343,6.206,7.874,3.862,12.349 C293.561,362.198,290.377,363.982,287.082,363.982z"
  })), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, React.createElement("g", null, React.createElement("circle", {
    style: {
      "fill": "#FFFFFF"
    },
    cx: 150.48,
    cy: 225.372,
    r: 9.15
  }), React.createElement("circle", {
    style: {
      "fill": "#FFFFFF"
    },
    cx: 368.849,
    cy: 225.372,
    r: 9.15
  })), _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

export default __webpack_public_path__ + "static/media/sad.927ca3b1.svg";
export { SvgComponent as ReactComponent };